import { useEffect, useState } from "react";
import { itemService } from "../../../services/item.service";

export function useItemPicker(query, type = null) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!query || query.length < 2) {
      setItems([]);
      return;
    }

    let active = true;

    setLoading(true);

    const params = { search: query };
    
    // Filter by type if provided
    if (type) {
      params.type = type;
    }

    itemService
      .picker(params)
      .then((res) => {
        if (active) setItems(res || []);
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [query, type]);

  return { items, loading };
}
